import http from '../../../plugins/axios';

export default {

    advertInsert(data){
        return http.post({
            url: '/admin/advertising/config/insert',
            data,
            dataType: 'form'
        })
    },

    advertUpdate(data){
        return http.post({
            url: '/admin/advertising/config/update',
            data,
            dataType: 'form'
        })
    },

    advertQuery(data){
        return http.get({
            url:'/admin/advertising/config/query',
            data
        })
    },

    feeQuery(data){
        return http.get({
            url: '/admin/otc/fee/query',
            data
        })
    },

    feeInsert(data){
        return http.post({
            url: '/admin/otc/fee/insert',
            data,
            dataType: 'form'
        })
    },

    feeUpdate(data){
        return http.post({
            url: '/admin/otc/fee/update',
            data,
            dataType: 'form'
        })
    },

    queryOtcStatistic(data){
        return http.get({
            url: '/admin/otcCount/tradeCount',
            data
        })
    }
}